if (!customElements.get('why-movement')) {
  customElements.define(
    'why-movement',
    class WhyMovement extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.grid = this.querySelector('[data-why-movement-grid]');
        this.mediaQuery = window.matchMedia('(min-width: 750px)');

        const sectionWrapper = this.closest('.shopify-section');
        const previousGrid = sectionWrapper?.previousElementSibling?.querySelector('.image-with-text__grid');
        const jeffHeading = [...document.querySelectorAll('.image-with-text__heading')].find(
          (heading) => heading.textContent.trim() === 'The accident that started the movement.'
        );
        this.referenceGrid =
          previousGrid || jeffHeading?.closest('.shopify-section')?.querySelector('.image-with-text__grid');

        if (!this.grid || !this.referenceGrid) return;

        this.syncHeight = () => {
          if (this.mediaQuery.matches) {
            this.grid.style.minHeight = `${Math.ceil(this.referenceGrid.getBoundingClientRect().height)}px`;
          } else {
            this.grid.style.removeProperty('min-height');
          }
        };

        this.resizeObserver = new ResizeObserver(this.syncHeight);
        this.resizeObserver.observe(this.referenceGrid);

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.syncHeight);
        } else {
          this.mediaQuery.addListener(this.syncHeight);
        }

        this.syncHeight();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();

        if (!this.syncHeight || !this.mediaQuery) return;
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.syncHeight);
        } else {
          this.mediaQuery.removeListener(this.syncHeight);
        }
      }
    }
  );
}
